import { createApp, h } from 'vue';
import DatGui from '@cyrilf/vue-dat-gui';
import "@cyrilf/vue-dat-gui/dist/style.css";

import App from './app.vue';
import router from './router';

const app = createApp({
  render: () => h(App)
})

app.config.productionTip = true;

app.use(router);

app.use(DatGui);

app.mount('#app');
